import { Box, Divider, Link, Typography } from '@mui/joy';
import {
	ChapterPreviewContainer,
	ChapterPreviewContainerProps
} from '../Chapters/ChapterPreviewContainer';

type Link = {
	label: string;
	href: string;
};

interface ChapterListProps extends ChapterPreviewContainerProps {
	header: string;
	subheader: string;
	links: Link[];
}
export const ChapterList = ({
	header,
	subheader,
	links,
	...props
}: ChapterListProps) => {
	return (
		<Box
			sx={{
				width: { xs: '287px', md: '313px' },
				margin: 0,
				marginBottom: { xs: '24px', md: '72px' }
			}}
		>
			<ChapterPreviewContainer
				{...props}
				backgroundGradientProps={{
					sx: {
						padding: '24px',
						paddingTop: '62px',
						justifyContent: 'start',
						alignItems: 'start',
						flexDirection: 'column',
						textAlign: 'left',
						height: '400px'
					},
					gradientHeight: 72,
					...props.backgroundGradientProps
				}}
				includeLowerDots
			>
				<Typography level='chartTitle' sx={{ fontWeight: 'bold' }}>
					{header}
				</Typography>
				<Typography
					level='chartSubtitle'
					sx={{
						lineHeight: '1.125rem',
						color: '#000000DE',
						marginTop: '10.5px',
						marginBottom: '6.5px'
					}}
				>
					{subheader}
				</Typography>
				<Divider sx={{ color: '#000000' }} />
				<Box sx={{ display: 'flex', flexDirection: 'column' }}>
					{links.map((link) => (
						<Link
							disabled={props.disabled}
							href={link.href}
							key={`${link.label}-${link.href}`}
							level={'body2'}
							underline='none'
							sx={{
								marginTop: '12px',
								':hover': { color: '#111827', textDecoration: 'none' },
								color: '#858585',
								'&.Mui-disabled	': {
									color: '#858585'
								}
							}}
						>
							{link.label}
						</Link>
					))}
				</Box>
			</ChapterPreviewContainer>
		</Box>
	);
};
